import React from 'react'

import { GoogleMapContext } from '../context/GoogleMapContext'

import type { ActiveMarker } from '../helpers/types/context/googlemap.types'
import type { UseGoogleMapReturn } from '../helpers/types/hooks/googlemap.types'

export function useGoogleMap(): UseGoogleMapReturn {
  const context = React.useContext(GoogleMapContext)

  function selectMarker(value: ActiveMarker | null): void {
    context.setActiveMarker(value)
  }

  function setZoom(zoom: number | undefined): void {
    if (zoom !== undefined) {
      context.setZoom(zoom)
    }
  }

  return {
    zoom: context.zoom,
    setZoom,
    activeMarker: context.activeMarker,
    selectMarker,
    viewType: context.viewType,
    setViewType: context.setViewType,
  }
}
